import { css, type Theme } from "@emotion/react";

import { baseStyles } from "@styles";

export const ModalHeader = css`
  padding-bottom: 2rem;
`;

export const modalShadow = (theme: Theme) => css`
  padding: 2rem;
  ${baseStyles.modalHeader(theme)}
`;

export const content = css`
  margin-right: 2rem;
`;
